'use strict'

import InputError from '../../lib/InputError';
import Failed from '../../lib/Failed';
import SecurityPassword from '../../lib/SecurityPassword';

class CreatePassword {
    
    constructor() {
        
    }

    init () {
        $('input[type="password"]').on('focus', (e) => {
            $(e.currentTarget).parent().removeClass('form-error');
        });
        $('input[name="repassword"]').on('keyup', function (e) {
            e.preventDefault();
            if (SecurityPassword.isWhich(e)) {
                $(this).parent().removeClass('form-validated');
                $(this).parent().find('.btn-view').show();
                if ($('input[name="password"]').val() === $(this).val()){
                    $(this).parent().addClass('form-validated');
                    $(this).parent().find('.btn-view').hide();
                    $('button[type="submit"]').removeAttr('disabled');
                } else {
                    $('button[type="submit"]').attr('disabled', 'disabled');
                }
            }
        });
        var security_info = {
            level:['security--','security--quiteweak','security--weak','security--strong'],
            text:['','Bastante débil','Débil','Perfecto']
        };
        $('input[name="password"]').on('keyup', function (e) {
            e.preventDefault();
            if (SecurityPassword.isWhich(e)) {
                $('input[name="repassword"]').trigger('keyup', [e]);
                $(this).parent().removeClass('form-validated');
                $(this).parent().find('.btn-view').show();
                security_info.level.forEach(function (s){
                    $('.security').removeClass(s);
                });
                if(!SecurityPassword.isLength($(this).val())){
                    $('.security').addClass('security--quiteweak');
                    $('.security__label').text('Debe tener una longitud entre 8 y 16');
                    return false;
                }
                if (!SecurityPassword.isAllowedCharacters ($(this).val())){
                    $('.security').addClass(security_info.level[0]);
                    $('.security__label').text(security_info.text[0]);
                    return false;
                }
                var level = SecurityPassword.check($(this).val());
                $('.security').addClass(security_info.level[level]);
                $('.security__label').text(security_info.text[level]);
                if (level >= 2){
                    $(this).parent().addClass('form-validated');
                    $(this).parent().find('.btn-view').hide();
                    return true;
                }
                return true;
            }
        });
        $('form[name="pwd"]').on('submit', (e) => {
            InputError.reset();
            $('button[type="submit"]').attr('disabled', 'disabled').addClass('disabled');
            $.ajax({
                url: $(e.currentTarget).attr('action'),
                type : "POST",
                dataType : 'json',
                data : $(e.currentTarget).serialize(),
                success : (data) => {
                    $('button[type="submit"]').removeAttr('disabled').removeClass('disabled');
                    if (data.status === 1){
                        return Failed.success({
                            'description':'Su contraseña ha sido guardada correctamente',
                            'link':{
                                'title':'Ingresá a tu cuenta',
                                'href':App.baseUrl + '/panel/login'
                            }
                        });
                    }
                    if (data.status === 2){
                        return Failed.show(data.message);
                    }
                    InputError.validate();
                    if (data.error){
                        InputError.show(data.error);
                    }
                },
                error: function(xhr, resp, text) {
                    console.log(xhr, resp, text);
                }
            });
            return false;
        });
    }
}

export default CreatePassword;